import clsx from "clsx"
export default function ArrowRight({ className = '' }) {
  return (
    <svg className={clsx(className, 'w-(--space-5) h-auto')} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 8H14M14 8L7.04841 2M14 8L7.04841 14" stroke="#38362D" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
